import React from 'react';
import '../css/ShopifyApp.css';

const SHOPIFY_APP_URL = 'https://apps.shopify.com/furloop-buyback';

const points = [
  {
    title: 'Install in one click',
    description:
      'Add Furloop Buyback from the Shopify App Store and it connects to your store automatically — no separate account, no setup calls.',
  },
  {
    title: 'Billed through Shopify',
    description:
      'Plans and pricing live on the App Store listing. Everything is charged on your existing Shopify bill, so there is nothing new to manage.',
  },
  {
    title: 'Trade-ins inside your storefront',
    description:
      'Customers get instant quotes and send in devices or collectibles from your own site, and every ticket lands in the Furloop dashboard.',
  },
];

const ShopifyBag = ({ className = '' }) => (
  <svg viewBox="0 0 109 124" aria-hidden="true" className={className}>
    <path
      fill="#95BF47"
      d="M95.9 23.9c-.1-.6-.6-1-1.1-1-.5 0-9.3-.2-9.3-.2s-7.4-7.2-8.1-7.9c-.7-.7-2.2-.5-2.7-.3l-3.7 1.2c-.4-1.3-1.1-2.9-2-4.5C66.1 5.6 62 2.7 57.2 2.7c-.3 0-.7 0-1 .1-.1-.2-.3-.3-.4-.5C53.6.1 51 -.9 47.8.1 41.7 1.9 35.6 7.9 30.7 17c-3.5 6.4-6.1 14.5-6.9 20.8l-11.8 3.7c-3.5 1.1-3.6 1.2-4 4.5C7.7 48.4 0 108.1 0 108.1l64.7 11.2 28-7C92.7 112.3 96 24.5 95.9 23.9z"
    />
    <path
      fill="#5E8E3E"
      d="M94.8 22.9c-.5 0-9.3-.2-9.3-.2s-7.4-7.2-8.1-7.9c-.3-.3-.6-.4-1-.5v104.9l28-7S96 24.5 95.9 23.9c-.1-.6-.6-1-1.1-1z"
    />
    <path
      fill="#FFF"
      d="M57.2 39.9l-3.3 12.2s-3.6-1.7-8-1.4c-6.4.4-6.4 4.4-6.4 5.4.4 5.5 14.8 6.7 15.6 19.5.6 10.1-5.3 17-14 17.5-10.4.7-16.1-5.5-16.1-5.5l2.2-9.4s5.7 4.3 10.3 4c3-.2 4.1-2.6 4-4.4-.5-7.2-12.2-6.8-13-18.4-.6-9.9 5.9-19.9 20.2-20.8 5.5-.4 8.5 1.3 8.5 1.3z"
    />
  </svg>
);

const ShopifyApp = () => {
  return (
    <section id="shopify-app" className="bg-gradient-to-b from-gray-100 to-white py-16 px-6">
      <div className="max-w-5xl mx-auto text-center">
        <a
          href={SHOPIFY_APP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-4 py-1.5 text-sm font-medium text-[#3B2B52] no-underline shadow-sm hover:border-[#95BF47] hover:no-underline"
        >
          <ShopifyBag className="h-5 w-5" />
          Available on the Shopify App Store
        </a>

        <h2 className="mt-5 text-3xl md:text-4xl font-medium text-[#3B2B52]">
          Furloop is a Shopify app
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-base md:text-lg text-gray-600">
          Run your buyback and trade-in program from the store you already have. Install
          Furloop Buyback from the App Store, pick a plan there, and start taking stock in
          today.
        </p>

        <div className="mt-10 grid gap-6 md:grid-cols-3 text-left">
          {points.map((item) => (
            <div key={item.title} className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
              <h3 className="text-lg font-semibold text-[#3B2B52]">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-gray-600">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={SHOPIFY_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="shopify-app-cta"
          >
            <ShopifyBag className="h-5 w-5" />
            View on the Shopify App Store
          </a>
          <span className="text-sm text-gray-500">Plans and pricing are listed on the App Store.</span>
        </div>
      </div>
    </section>
  );
};

export default ShopifyApp;
